module.exports = __webpack_public_path__ + "img/mobile-qr.d99f2a5d.jpg";